export default __webpack_public_path__ + "static/media/convertToOrder.33b1c6b6.svg";